module.exports = __webpack_public_path__ + "img/ol.bd84b990.svg";